import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import PageHeader from "@/components/PageHeader";
import Reveal from "@/components/Reveal";
import CTASection from "@/components/CTASection";
import { SERVICES } from "@/data/site";

const Services = () => {
  useEffect(() => {
    document.title = "Services — Click World Online";
  }, []);
  return (
    <>
      <PageHeader
        eyebrow="Our Services"
        title={<>Everything digital. <span className="text-electric">Done deliberately.</span></>}
        text="Twelve focused services that work as one connected system. Explore what each can do for your business."
      />
      <section data-testid="services-grid-section" className="bg-navy-deep">
        <div className="max-w-8xl mx-auto px-6 lg:px-12 py-20 lg:py-32">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
            {SERVICES.map((s, i) => (
              <Reveal key={s.slug} delay={0.04 * (i % 3)}>
                <Link
                  to={`/services/${s.slug}`}
                  data-testid={`service-card-${s.slug}`}
                  className="group relative flex flex-col h-full bg-navy-light border border-white/10 rounded-3xl p-8 overflow-hidden hover:border-electric/40 transition-colors duration-300"
                >
                  <div className="absolute -top-16 -right-16 w-48 h-48 bg-brand/20 blur-[80px] rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-500" aria-hidden="true" />
                  <span className="font-display text-sm font-bold text-mist/30 group-hover:text-electric transition-colors duration-300">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <h2 className="mt-4 font-display text-2xl font-extrabold tracking-tight text-mist group-hover:text-electric transition-colors duration-300">
                    {s.title}
                  </h2>
                  <p className="mt-3 text-slatec text-sm leading-relaxed flex-1">{s.short}</p>
                  <span className="mt-6 inline-flex items-center gap-2 text-sm font-semibold text-mist/60 group-hover:text-electric group-hover:gap-3 transition-[gap,color] duration-300">
                    View service <ArrowUpRight size={16} />
                  </span>
                </Link>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
      <CTASection title="Not sure where to start?" text="That's exactly what the Discover stage is for. Tell us about your business — we'll recommend the right starting point." />
    </>
  );
};

export default Services;
